<template>
  <div class="content-panel" id="klienti-window" @scroll="paginationCheck($event)">
    <div class="statistics">
      <div class="stat-bar-filter">
        <div class="filter-flex-custom">
          <klienti-filters-bar ref="filters"/>
          <div class="clients-toolbar-actions">
            <router-link v-if="$store.getters['userState/getRole'] === 'financnik'" class="toolbar-action" to="/marketing/">Kampane a kontakty</router-link>
            <button class="toolbar-action" type="button" title="Vymazať filtre" @click="resetFilters">
              <img src="@/images/reset-circular.svg" alt=""/>
              <span>Reset</span>
            </button>
            <button
              class="toolbar-action"
              :class="{'is-active': statsShown}"
              type="button"
              :aria-expanded="statsShown ? 'true' : 'false'"
              title="Zobraziť štatistiky"
              @click="toggleStats"
            >
              <svg
                width="25"
                height="25"
                viewBox="0 2 15 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="statistic-icon"
              >
                <path
                  d="M0.875 0.875V10.875C0.875 11.5582 1.44184 12.125 2.125 12.125H12.125V10.875H2.125V0.875H0.875ZM11.0752 2.94653L8.36768 5.62842L6.49634 3.83887L2.93921 7.302L3.81079 8.198L6.50366 5.57593L8.38232 7.37158L11.9553 3.83398L11.0752 2.94653Z"
                  fill="white"
                />
              </svg>
              <span>Štatistiky</span>
            </button>
          </div>
        </div>
        <klienti-stats v-if="statsShown"/>
      </div>
    </div>
    <klienti-item-wrapper @pagination-check="paginationCheck" @reset-pagination="paginationLoading = false" @select-tab="activeTab = $event"/>
  </div>
</template>

<script>
import KlientiStats from "../../../components/broker/KartaKlienti/KlientiStats";
import KlientiItemWrapper from "../../../components/broker/KartaKlienti/KlientiItemWrapper";
import KlientiFiltersBar from "../../../components/broker/KartaKlienti/KlientiFiltersBar";

export default {
  name: "KartaKlienti",
  components: {
    KlientiFiltersBar,
    KlientiItemWrapper,
    KlientiStats
  },
  data: () => ({
    conversionFilter: null,
    paginationLoading: false,
    statsShown: false,
    brokerFilter: null,
    periodFilter: null,
    searchFilter: null,
    scroll: 0,
    activeTab: null,
  }),
  created () {
    const role = this.$store.getters["userState/getRole"];
    if (role !== "alex_admin") {
      let financnik = this.$store.getters["userState/getId"];
      this.$store.commit("clientState/updateAllClientsConfigs", {financnik});
    }

    this.$store.dispatch("clientState/fetchAllClientsFromConfig");
    this.$store.dispatch("clientState/fetchClientAnalytics");
  },
  beforeDestroy() {
    this.$store.commit("clientState/nullState");
  },
  methods: {
    resetFilters() {
      this.$refs.filters.resetFilters();
      this.$store.commit("clientState/resetClientsConfig");
      if (this.$store.getters['userState/getRole'] !== 'alex_admin') {
        this.$store.commit('clientState/updateAllClientsConfigs', {financnik: this.$store.getters['userState/getId']});
      }
      this.$store.commit("clientState/resetClientAnalyticsFilters");
      this.$store.dispatch("clientState/fetchAllClientsFromConfig");
      this.$store.dispatch("clientState/fetchClientAnalytics");
    },
    async paginationCheck () {
      const el = document.getElementById("klienti-window");
      const position = window.innerHeight + Math.ceil(el.scrollTop);

      console.log(position, el.scrollHeight);

      if (el.scrollHeight <= position && !this.paginationLoading) {
        this.paginationLoading = true;
        await this.$store.dispatch("clientState/fetchClientsNextPageByType", this.activeTab);
        this.paginationLoading = false;
      }
    },
    toggleStats () {
      this.statsShown = !this.statsShown;
    },
  },
};
</script>

<style scoped lang="scss">
.content-panel {

}

.hide-statistic-item {
  padding-right: 25px;
}

.stat-bar-filter {
  padding: 18px 22px;
  border-radius: 16px;
  box-shadow: 0 14px 34px rgba(23, 82, 151, 0.2);
}

.filter-flex-custom {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

::v-deep .filter-control {
  gap: 10px;
  flex-wrap: wrap;
}

.clients-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.toolbar-action {
  display: inline-flex;
  min-height: 38px;
  padding: 0 11px;
  align-items: center;
  gap: 7px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 11px;
  background: rgba(8, 27, 76, 0.12);
  color: rgba(255, 255, 255, 0.82);
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;
}

.toolbar-action:hover,
.toolbar-action.is-active {
  border-color: rgba(255, 255, 255, 0.62);
  background: rgba(8, 27, 76, 0.28);
  color: #fff;
  transform: translateY(-1px);
}

.toolbar-action img,
.toolbar-action svg {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
}

.toolbar-action img {
  filter: brightness(0) invert(1);
}

.toolbar-action .statistic-icon {
  padding: 0;
}

@media (max-width: 767px) {
  .filter-flex-custom {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
  }

  .clients-toolbar-actions {
    justify-content: flex-end;
  }
}

.search-bar {
  width: 700px;
  position: absolute;
  left: 750px;
  top: 29px;
}
</style>
